<template>
	<div class="main-layout">
		<div class="main-layout__nav-container">
			<nav ref="navRef" class="main-layout__nav">
				<GlobalLogo></GlobalLogo>
			</nav>
		</div>
		<GlobalBooker nav />
		<slot />
		<GlobalIntercomFacade />
	</div>
</template>

<script setup lang="ts">
const navRef = ref<HTMLElement | null>(null)
const navHeight = computed(() => {
	return navRef.value?.clientHeight
})

provide('navHeight', navHeight)
</script>

<style lang="scss">
@import './main';
</style>
